import React from "react";
import { PartyList } from "@/pages/Customers";

export default function Vendors() {
    return <PartyList kind="vendor" />;
}
